import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackEvent } from "@/lib/analytics";

declare global {
  interface Window {
    rdt?: (...args: unknown[]) => void;
  }
}

export const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);

    // Scoped to GA4 via trackEvent — keeps page_view out of the Ads account.
    trackEvent('page_view', {
      page_path: pathname,
      page_location: window.location.href,
    });

    if (window.rdt) {
      window.rdt('track', 'PageVisit', { conversionId: crypto.randomUUID() });
    }
  }, [pathname]);

  return null;
};
